module.exports = __webpack_public_path__ + "img/goodHealthAndWellBeing.9ae4b682.png";